<template>
  <div id="HotDetails" :style="flag?'padding-bottom:.5rem':''">
    <Head v-if="!flag" />
    <!-- <Login @isLoginOpen="isLoginOpen" v-if="isLogin" /> -->
    <header v-if="flag" class="head">
      <img src="../assets/move/1.png" alt />
    </header>
    <div class="hMain" v-if="!flag">
      <p>{{news.Title}}</p>
      <p>
        发布时间： {{news.Date}} 来源：{{news.Source}}
        <span></span>
        阅读量：{{news.ClickNums}}次
      </p>

      <div v-if="news.Details" class="ql-editor ql2" v-html="news.Details"></div>

      <div class="fj" v-if="news.DocLink1">
        <p>
          附件:
          <span>(pdf文件请右键保存下载)</span>
        </p>
        <ul>
          <li @mouseover="nMouse(1)" @mouseout="hy">
            <a :class="{'active':index==1}" :href="news.DocLink1">{{news.DocLink1.split("/")[news.DocLink1.split("/").length-1]}}</a>
          </li>
          <li @mouseover="nMouse(2)" @mouseout="hy">
            <a :href="news.DocLink2" :class="{'active':index==2}">{{news.DocLink2.split("/")[news.DocLink2.split("/").length-1]}}</a>
          </li>
          <li @mouseover="nMouse(3)" @mouseout="hy">
            <a :href="news.DocLink3" :class="{'active':index==3}">{{news.DocLink3.split("/")[news.DocLink3.split("/").length-1]}}</a>
          </li>
          <li @mouseover="nMouse(4)" @mouseout="hy">
            <a :href="news.DocLink4" :class="{'active':index==4}">{{news.DocLink4.split("/")[news.DocLink4.split("/").length-1]}}</a>
          </li>
          <li @mouseover="nMouse(5)" @mouseout="hy">
            <a :href="news.DocLink5" :class="{'active':index==5}">{{news.DocLink5.split("/")[news.DocLink5.split("/").length-1]}}</a>
          </li>
          <li @mouseover="nMouse(6)" @mouseout="hy">
            <a :href="news.DocLink6" :class="{'active':index==6}">{{news.DocLink6.split("/")[news.DocLink6.split("/").length-1]}}</a>
          </li>
        </ul>
      </div>
      <div>
        <p>网站声明：凡本网转载自其它媒体的各类新闻，转载目的在于传递更多信息，并不代表本网赞同</p>
        <p>其观点和对其真实性负责。</p>
      </div>
    </div>
    <div class="move" v-else>
      <p class="title">{{news.Title}}</p>
      <p class="information">
        发布时间： {{news.Date}} 来源：{{news.Source}}
        <span></span>
        阅读量：{{news.ClickNums}}次
      </p>
      <div class="ql-editor" id="parent">
        <div v-html="news.Details"></div>
        <!-- <News :html="html" v-if="html"></News> -->
        <!-- <template slot-scope="scope">
          <div  style="background:#000">2222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222</div>
        </template>-->
      </div>
      <div class="statement">
        <p>网站声明：凡本网转载自其它媒体的各类新闻，转载目的在于传递更多信息，并不代表本网赞同其观点和对其真实性负责。</p>
      </div>
      <Previewer :imgSrc="imgSrc" v-if="showImg" @clickit="viewIng"></Previewer>
    </div>
    <Foot v-if="!flag" />
  </div>
</template>
<style lang="less">
#HotDetails {
  .head {
    margin-top: 0.3rem;
    width: 100%;
    height: 0.85rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .move {
    padding: 0.2rem 0.3rem 0.3rem 0.3rem;
    > p {
      text-align: center;
    }
    .title {
      font-size: 0.3rem;
      font-weight: 700;
      margin: 0.35rem 0 0.2rem 0;
    }
    .information {
      background: #f4f9fd;
      padding: 0.2rem 0;
      color: #797979;
    }
    .ql-editor {
      padding-top: 0.4rem;
      p {
        span {
          font-size: 16px !important;
        }

        max-width: 100%;
        img {
          max-width: 90% !important;
          display: block !important;
          margin: 0 auto;
        }
      }
    }
    .statement {
      font-size: 14px;
      color: #ccc;
      margin-top: 0.5rem;
      line-height: 0.5rem;
    }
  }
  .ql2 {
    p {
      max-width: 80%;
      margin: 0 auto;
      img {
        max-width: 80%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Previewer from "../components/Previewer";
// import Login from "../components/Login";

export default {
  data() {
    return {
      rou: "", //id 代表动态  news//新闻下标
      showImg: false,
      news: {},
      index: "",
      flag: "",
      imgSrc: "",
      html: ""
    };
  },
  created() {
    this.rou = this.$route.query.newsID;
  },
  mounted() {
    this.isMobile();
    this.getDet();
  },

  methods: {
    viewImg() {
      this.showImg = false;
    },
    // aaa(e) {
    //   if (e.target.localName.toLowerCase() == "img") {
    //     this.imgSrc = e.toElement.src;
    //     this.showImg = true;
    //   }
    // },

    isMobile() {
      console.log(navigator.userAgent);
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) this.flag = true;
    },

    nMouse(i) {
      this.index = i;
    },
    hy() {
      this.index = "";
    },
    getDet() {
      let that = this;
      that.$axios
        .post(
          "information/info?",
          that.$qs.stringify({
            ID: that.rou
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            that.news = res.data.data;
            // var html = res.data.data.Details;
            // var arr = html.split("img");
            // var str = "";
            // arr.forEach(val => {
            //   if (val.indexOf("src") != -1) {
            //     val = "@click='getImg(1)'" + val;
            //   }
            //   str += val;
            // });

            // this.html = str;

            // console.log(this.html);
            // var arr = res.data.data.Details.split("src=");
            // arr.splice(0, 1);
            // var image = [];
            // var reg = new RegExp('"', "g");
            // arr.map(val => {
            //   image.push(val.split("style")[0].replace(reg, ""));
            // });
            // console.log(image);
            // this.image = image;
          }
        });
    }

    // isLoginOpen(e) {
    //   this.isLogin = e;
    // }
  },

  components: {
    Head,
    Foot,
    Previewer
    // News: {
    //   props: { html: String },
    //   render: h=> {
    //     const com = Vue.extend({
    //       template: `<div class="ql-editor">${this.$parent.html}</div>`
    //     });

    //     return h(com, {});
    //   }
    // }
    // Previewer
    // Login
  }
};
</script>

<style lang="less" scoped>
.hMain {
  position: relative;
  // width: calc(100% - 0.4rem);
  width: 85%;
  // height: 100%;
  border: 0.01rem solid #ababab;
  margin: 0 auto;
  margin-top: 0.5rem;
  padding: 0.3rem;
  padding-top: 0.5rem;
  background: #fafdff;
  > span {
    display: inline-block;
    width: 0.15rem;
  }
  > p {
    width: 97%;
    font-size: 0.22rem;
    margin: 0 auto;
    padding-bottom: 0.1rem;
    color: #4f4f4f;
    text-indent: 2em;
    margin-bottom: 0.1rem;
    span {
      display: inline-block;
      width: 0.15rem;
    }
  }
  > p:nth-of-type(1) {
    text-align: center;
    font-size: 0.35rem;
    color: #333;
    border-bottom: 1px solid #ccc;
    padding-bottom: 0.3rem;
    font-weight: bold;
    margin: 0.3rem 0;
  }
  > p:nth-of-type(2) {
    height: 0.5rem;
    line-height: 0.5rem;
    background: #f4f9fd;
    text-align: center;
    font-size: 0.18rem;
    color: #666666;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
  }
  div {
    width: 96%;
    border: 1px dashed #ddd;
    // background: #f0f6fb;
    margin: 0.6rem 0 0 0.2rem;
    padding: 0.1rem 0;
    font-size: 0.2rem;
    text-indent: 2em;
    p {
      line-height: 1.5;
    }
    p:nth-of-type(1) {
      margin-bottom: 0.1rem;
    }
  }
  .fj {
    p {
      margin: 0.3rem 0 0.2rem !important;
      > span {
        // display: inline-block;

        font-size: 0.16rem;
        color: gray;
      }
    }
    ul {
      padding-left: 0.6rem;
    }
    li {
      font-size: 0.16rem;
      text-decoration: underline;
      margin-bottom: 0.2rem;
      a.active {
        color: royalblue;
      }
    }
  }
}
</style>